module.exports = "<div ng-if=\"showCheckbox()\" class=\"checkboxFiPreferred sCheckbox checkbox\" ng-class=\"plan.primaryFs.name\" content>\n    <input type=\"checkbox\" ng-model=\"makeFiPreferred.selected\" name=\"makeFiPreferred\" id=\"makeFiPreferred\" ng-change=\"actions.toggleModel()\">\n    <label for=\"makeFiPreferred\">{{\n    \tcontent(\n    \t\t'memberReview.prefer_' + plan.primaryFs.type,\n    \t\t{ name: content('fsMappings.'+ plan.primaryFs.name) }\n    \t)\n\t}}</label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/preferred-checkbox/template.html
// module id = ./components/xo-member-components/src/preferred-checkbox/template.html
// module chunks = 1